import { OffboardingSectionForm } from "../../components/offboarding-section-form/index.ts";

export interface ResignationFormProps {
    offboardingId: number;
    onSubmitSuccess: () => void;
}

export function ResignationForm({ offboardingId, onSubmitSuccess }: ResignationFormProps) {
    return (
      <OffboardingSectionForm
        offboardingId={offboardingId}
        sectionType="RESIGNATION"
        submitLabel="Submit"
        successMessage="Offboarding request submitted successfully."
        onSubmitSuccess={onSubmitSuccess}
      />
    );
}
